'use strict';

export class RevisionStatus {
  static Archived = 'Archived';
  static Publication = 'Publication';
  static Draft = 'Draft';
}
